import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StatusService {

  constructor(private http: HttpClient) { }

  getStatus() {
    return this.http.get(`${environment.apiUrl}/status`);
  }

  getSystemLogs() {
    return this.http.get(`${environment.apiUrl}/status/logs`);
  }
}
